import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { PermissionGuardDirective } from './guards/permission-guard.directive';



@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [PermissionGuardDirective],
  declarations: [PermissionGuardDirective]
})
export class SecuritySharedModule {
  constructor() {

  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/security-shared.module.ts